<template>
  <div class="select_box safe-distance-top-header">
    <Header :pageTitle="$route.meta.title"></Header>
    <div class="box ds_box">
      <div class="box_left">
        <img src="@/assets/img/mobile-img/ds_serve.png" alt="" />
        <div>
          <h1>电商业务</h1>
          <p>提供图书、会议、课程等业务支付和交易资金结算、分享推广等服务</p>
        </div>
      </div>
      <Button class="box_btn ds_btn" @click="toForm(2)">开通</Button>
    </div>
    <div class="box tsg_box">
      <div class="box_left">
        <img src="@/assets/img/mobile-img/tsg_serve.png" alt="" />
        <div>
          <h1>期刊投审稿业务</h1>
          <p>提供期刊投审稿业务支付和交易资金结算的服务</p>
        </div>
      </div>
      <Button class="box_btn tsg_btn" @click="toForm(1)">开通</Button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Header from "@/views/mobileView/components/header";
export default {
  name: "ServiceSign",
  components: {
    Header,
  },
  methods: {
    async toForm(type) {
      const res = await this.$apis.zzsignServe.signProgress({ type });
      if (res.data && res.data.resCode === "0000") {
        const { applyStatus, umsRegId, applyStatusMsg } = res.data;
        switch (applyStatus) {
          case "00":
            this.$router.push(
              `/service-sign/agreement-sign?type=${type}&umsRegId=${umsRegId}`
            );
            break;
          case "05":
            this.$router.push(
              `/service-sign/public-verification?type=${type}&umsRegId=${umsRegId}`
            );
            break;
          case "02":
          case "03":
          case "04":
            this.$router.push(
              `/service-sign/sign-result?type=${type}&umsRegId=${umsRegId}`
            );
            break;
          default:
            Toast(applyStatusMsg);
            break;

        }
      } else {
        this.$router.push(`/service-sign?type=${type}`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.select_box {
  padding: 56px 12px 12px;

  .box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 12px;
    border-radius: 8px;

    .box_left {
      display: flex;
      align-items: center;
      flex: 1;
      margin-right: 24px;

      img {
        margin-right: 12px;
        width: 54px;
        height: 54px;
      }

      h1 {
        font-size: 16px;
        color: #333333;
        line-height: 23px;
      }

      p {
        margin-top: 12px;
        font-size: 13px;
        color: #999999;
        line-height: 19px;
      }
    }

    .box_btn {
      width: 75px;
      height: 32px;
      border-radius: 18px;
      font-size: 14px;
      color: #ffffff;
    }
  }

  .ds_box {
    background: linear-gradient(180deg, #fff3f4 0%, #ffffff 100%);
    border: 1px solid #ffd5d5;

    .ds_btn {
      background: #ff3d3d;
    }
  }

  .tsg_box {
    margin-top: 12px;
    background: linear-gradient(180deg, #eaf0ff 0%, #ffffff 100%);
    border: 1px solid #becdff;

    .tsg_btn {
      background: #4a79f1;
    }
  }
}</style>